"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.primaryColorDark = exports.primaryColorLight = exports.primaryColor = exports.secondaryColor = exports.grey5 = exports.grey4 = exports.grey3 = exports.grey2 = exports.grey1 = exports.white = exports.black = exports.red = exports.darkRed = exports.lightRed = exports.darkYellow = exports.lightYellow = exports.yellow = exports.darkGreen = exports.lightGreen = exports.green = exports.darkBlue = exports.lightBlue = exports.blue = void 0;
// primaries
var blue = '#4A90E2';
exports.blue = blue;
var lightBlue = '#B1D9FF';
exports.lightBlue = lightBlue;
var darkBlue = '#2B598E';
exports.darkBlue = darkBlue;
var green = '#3EB642';
exports.green = green;
var lightGreen = '#97ECA5';
exports.lightGreen = lightGreen;
var darkGreen = '#2E8230';
exports.darkGreen = darkGreen;
var yellow = '#FFE204';
exports.yellow = yellow;
var lightYellow = '#FDE69D';
exports.lightYellow = lightYellow;
var darkYellow = '#F1C90F';
exports.darkYellow = darkYellow;
var lightRed = '#FFBFBE';
exports.lightRed = lightRed;
var darkRed = '#B72F2E';
exports.darkRed = darkRed;
var red = '#E04341'; // grey scale

exports.red = red;
var black = '#000000';
exports.black = black;
var white = '#ffffff';
exports.white = white;
var grey1 = '#F9F9F9';
exports.grey1 = grey1;
var grey2 = '#EAEAEE';
exports.grey2 = grey2;
var grey3 = '#C2C2C2';
exports.grey3 = grey3;
var grey4 = '#A7A7A7';
exports.grey4 = grey4;
var grey5 = '#48484D'; // quark branding

exports.grey5 = grey5;
var secondaryColor = lightBlue;
exports.secondaryColor = secondaryColor;
var primaryColor = blue;
exports.primaryColor = primaryColor;
var primaryColorLight = '#ACCAED';
exports.primaryColorLight = primaryColorLight;
var primaryColorDark = '#2B598E';
exports.primaryColorDark = primaryColorDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/styles/colors.js
// module id = ./node_modules/quark-core/styles/colors.js
// module chunks = 0